<div *ngIf="{ displayProduct: displayProduct$ | async, variantProduct: variantProduct$ | async } as product"
  role="alert">
  <dcp-generic-configurator-error imgPath="../../../../assets/images/configurator/checkout-unavailable-error.png"
    headline="configurator.error.checkoutUnavailable.headline" [isCheckoutUnavailable]=true>
  </dcp-generic-configurator-error>
  <div class="row justify-content-center">
    <div class="col-sm-7 col-11">
      <p class="text-center body--s">
        {{'configurator.error.checkoutUnavailable.message1' | cxTranslate }}
        <span *ngIf="error?.errorCode"
         class="checkout-unavailable-error text-nowrap"
         >&nbsp;{{'configurator.error.code' | cxTranslate: {errorCode: error.errorCode} }}
        </span>
      </p>
      <p class="text-center body--s">
        <span>
          {{'configurator.error.checkoutUnavailable.message2' | cxTranslate }}
        </span>
        <dcp-contact-us-button class="d-inline" [isButton]="false"
          buttonText="{{'configurator.error.checkoutUnavailable.buttonText2'}}">
        </dcp-contact-us-button>
      </p>
    </div>
  </div>
  <div class="row">
    <div class="col d-flex flex-column flex-sm-row justify-content-center">
        <dcp-cancel-cta-button [displayProduct]="product.displayProduct"
          buttonText="{{'configurator.error.checkoutUnavailable.buttonText'}}">
        </dcp-cancel-cta-button>
    </div>
  </div>
</div>
